import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DeviceAdsService = {
  // Get ads by MAC ID
  getAdsByMacId: async (macId) => {
    try {
      const response = await apiService.get(`/devicesads/by-mac/${macId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching device ads:", error);
      throw error;
    }
  },

  // Set ad as inactive
  setAdInactive: async (adId, macId) => {
    try {
      const response = await apiService.delete(
        `/devicesads/set-inactive/${adId}`,
        {
          params: {
            macId: macId,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error setting ad as inactive:", error);
      throw error;
    }
  },

  // Bulk assign campaigns to devices
  bulkAssignCampaigns: async (data) => {
    try {
      const response = await apiService.post("/devicesads/bulk-assign", data);
      return response.data;
    } catch (error) {
      console.error("Error bulk assigning campaigns:", error);
      throw error;
    }
  },

  // Delete campaigns from a device
  deleteCampaigns: async (macId, campaignIds) => {
    try {
      const payload = {
        macId: macId,
        campaignIds: campaignIds,
      };
      const response = await apiService.post(
        "/devicesads/delete/campaigns",
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting campaigns:", error);
      throw error;
    }
  },
};

export default DeviceAdsService;
